var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from "lit/decorators.js";
import { css, html, LitElement } from "lit";
import { surfaceColor, defaults, primaryColor, outlineVariantColor, onSurfaceColor, } from "../style";
let FramePickerComponent = class FramePickerComponent extends LitElement {
    constructor() {
        super(...arguments);
        this.current = 0;
    }
    static get styles() {
        return [defaults,
            css `
              :host {
                width: 400px;
                display: block;
              }

              input {
                  --c: ${primaryColor}; /* active color */
                  --g: 1px; /* the gap */
                  --l: 4px; /* line thickness*/
                  --s: 20px; /* thumb size*/

                  width: 400px;
                  height: var(--s); /* needed for Firefox*/
                  --_c: color-mix(in srgb, var(--c), #000 var(--p,0%));
                  -webkit-appearance :none;
                  -moz-appearance :none;
                  appearance :none;
                  background: none;
                  cursor: pointer;
                  overflow: hidden;
                }
                input:focus-visible,
                input:hover{
                  --p: 15%;
                }
                input:active,
                input:focus-visible{
                  --_b: var(--s)
                }
                /* chromium */
                input[type="range" i]::-webkit-slider-thumb{
                  height: var(--s);
                  aspect-ratio: 1;
                  border-radius: 50%;
                  box-shadow: 0 0 0 var(--s) inset var(--_c);
                  border-image: linear-gradient(90deg,var(--_c) 50%, ${outlineVariantColor} 0) 1/0 100vw/0 calc(100vw + var(--g));
                  clip-path:
                          polygon(
                                  0     calc(50% + var(--l)/2),
                                  -100vw calc(50% + var(--l)/2),
                                  -100vw calc(50% - var(--l)/2),
                                  0     calc(50% - var(--l)/2),
                                  0 0,100% 0,
                                  100%  calc(50% - var(--l)/2),
                                  100vw calc(50% - var(--l)/2),
                                  100vw calc(50% + var(--l)/2),
                                  100%  calc(50% + var(--l)/2),
                                  100% 100%,0 100%);
                  -webkit-appearance: none;
                  appearance: none;
                }
                /* Firefox */
                input[type="range"]::-moz-range-thumb {
                  height: var(--s);
                  width: var(--s);
                  background: none;
                  border-radius: 50%;
                  box-shadow: 0 0 0 var(--s) inset var(--_c);
                  border-image: linear-gradient(90deg,var(--_c) 50%, ${outlineVariantColor} 0) 1/0 100vw/0 calc(100vw + var(--g));
                  clip-path:
                          polygon(
                                  0     calc(50% + var(--l)/2),
                                  -100vw calc(50% + var(--l)/2),
                                  -100vw calc(50% - var(--l)/2),
                                  0     calc(50% - var(--l)/2),
                                  0 0,100% 0,
                                  100%  calc(50% - var(--l)/2),
                                  100vw calc(50% - var(--l)/2),
                                  100vw calc(50% + var(--l)/2),
                                  100%  calc(50% + var(--l)/2),
                                  100% 100%,0 100%);
                  -moz-appearance: none;
                  appearance: none;
                }
              
                .btn-group {
                  position: relative;
                  display: flex;
                  vertical-align: middle;
                  border-radius: 20px;
                  background-color: ${primaryColor};
                  margin: 0 auto 12px auto;
                  width: fit-content;
                }
              
                button {
                  padding: 6px 12px;
                  border: 1px solid ${outlineVariantColor};
                  border-right: 0;
                  position: relative;
                  flex: 1 1 auto;
                  color: ${primaryColor};
                  cursor: pointer;
                  background-color: ${surfaceColor};
                }
              
                button:hover, button:active {
                  opacity: 0.9;
                }
              
                button:disabled {
                  opacity: 1;
                  cursor: initial;
                  color: ${onSurfaceColor};
                }

                .btn-group > button:last-of-type {
                  border-right: 1px solid ${outlineVariantColor};
                  border-top-right-radius: 20px;
                  border-bottom-right-radius: 20px;
                }
              
                .btn-group > button:first-of-type {
                    border-top-left-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
            `
        ];
    }
    updated(changedProperties) {
        if (changedProperties.has("value")) {
            this.current = this.value;
        }
    }
    get displayedCurrent() {
        return this.current + 1;
    }
    get max() {
        return this.length - 1;
    }
    handleFrameChange(frame) {
        this.current = frame;
        this.dispatchEvent(new CustomEvent("frame-change", {
            detail: {
                frame: frame
            },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        return html `
            <input type="range" min="0" max="${this.length - 1}" .value="${this.current}" @input="${(e) => this.handleFrameChange(e.target.valueAsNumber)}">
            <div class="btn-group">
                <button @click=${() => this.handleFrameChange(0)} .disabled=${this.current == 0}><<</button>
                <button @click=${() => this.handleFrameChange(this.current - 1)} .disabled=${this.current == 0}><</button>
                <button disabled>${this.displayedCurrent} / ${this.length}</button>
                <button @click=${() => this.handleFrameChange(this.current + 1)} .disabled=${this.current == this.max}>\></button>
                <button @click=${() => this.handleFrameChange(this.max)} .disabled=${this.current == this.max}>\>\></button>
            </div>
        `;
    }
};
__decorate([
    property({ type: Number })
], FramePickerComponent.prototype, "length", void 0);
__decorate([
    property({ type: Number })
], FramePickerComponent.prototype, "value", void 0);
__decorate([
    property({ type: Number, state: true })
], FramePickerComponent.prototype, "current", void 0);
FramePickerComponent = __decorate([
    customElement('tc-frame-picker')
], FramePickerComponent);
export { FramePickerComponent };
//# sourceMappingURL=FramePicker.js.map